import VisuallyHidden from "@insite/mobius/VisuallyHidden/VisuallyHidden";

export default VisuallyHidden;
